import React, { useState } from "react";
import { Link } from "react-router-dom";
import circleText from "../../assets/img/home_1/UNepal-text_dark.webp";
import { IHomeAboutUsData } from "../../exports/interfaces";
import { useBrochureContext } from "../../context/BrochureContext";
import { PdfViwer } from "../PdfViwer";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import { stripHtml } from "../../exports/functions";

export const AboutUs = (props: { aboutUsData: IHomeAboutUsData[] }) => {
  // const location = useLocation();

  // const navigate = useNavigate();

  // const handleBannerButtonClick = (
  //   e: React.MouseEvent<HTMLElement>,
  //   pathname: string,
  //   hash: string,
  // ) => {
  //   e.preventDefault();

  //   if (location.pathname === `/${pathname}`) {
  //     document.getElementById(hash)?.scrollIntoView({
  //       behavior: "smooth",
  //     });
  //   } else {
  //     navigate(`/${pathname}#${hash}`);
  //   }
  // };
  const { brochureData, undergraduateBrochureData, mppBrochureData } =
    useBrochureContext();

  const [showBrochurePopup, setShowBrochurePopup] = useState(false);

  const [openPdf, setOpenPdf] = useState(false);
  const [pdfPath, setPdfPath] = useState("");

  const openViewer = (path: string) => {
    setPdfPath(path);
    setOpenPdf(true);
  };

  const closeViewer = () => setOpenPdf(false);

  const brochures = [
    {
      title: "Our Brochure",
      link:
        brochureData[0]?.file && brochureData[0]?.file.length > 0
          ? brochureData[0]?.file[0]?.media?.url
          : stripHtml(brochureData[0]?.link),
    },
    {
      title: "Undergraduate Brochure",
      link:
        undergraduateBrochureData[0]?.file &&
        undergraduateBrochureData[0]?.file.length > 0
          ? undergraduateBrochureData[0]?.file[0]?.media?.url
          : stripHtml(undergraduateBrochureData[0]?.link),
    },
    {
      title: "MPP Brochure",
      link:
        mppBrochureData[0]?.file && mppBrochureData[0]?.file.length > 0
          ? mppBrochureData[0]?.file[0]?.media?.url
          : stripHtml(mppBrochureData[0]?.link),
    },
  ];

  const openAdsDrawer = () => {
    const el = document.getElementById("offcanvasRight");

    if (el) {
      const offcanvas = new Offcanvas(el);
      offcanvas.show();
    }
  };

  return (
    <>
      <section>
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_about td_style_1">
          <div className="container">
            <div className="row td_gap_y_40">
              <div
                className="col-lg-6 wow fadeInLeft"
                data-wow-duration="1s"
                data-wow-delay="0.25s"
              >
                <div className="td_about_thumb_wrap">
                  {/* <div className="td_about_year text-uppercase td_fs_64 td_bold">
                  EST 2024
                </div> */}
                  <div className="td_about_thumb_1">
                    <img
                      src={`${process.env.REACT_APP_cmsUrl}${props?.aboutUsData[0]?.image_1[0]?.media?.url}`}
                      alt="About"
                    />
                  </div>
                  <div className="td_about_thumb_2">
                    <img
                      src={`${process.env.REACT_APP_cmsUrl}${props?.aboutUsData[0]?.image_2[0]?.media?.url}`}
                      alt="About"
                    />
                  </div>

                  <button
                    onClick={openAdsDrawer}
                    className="td_circle_text td_center td_video_open"
                  >
                    <svg
                      width="15"
                      height="19"
                      viewBox="0 0 15 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.086 8.63792C14.6603 9.03557 14.6603 9.88459 14.086 10.2822L2.54766 18.2711C1.88444 18.7303 0.978418 18.2557 0.978418 17.449L0.978418 1.47118C0.978418 0.664496 1.88444 0.189811 2.54767 0.649016L14.086 8.63792Z"
                        fill="#2f2b75"
                      />
                    </svg>
                    <img src={circleText} alt="Circle Logo" className="" />
                  </button>
                </div>
              </div>
              <div
                className="col-lg-6 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay="0.3s"
              >
                <div className="td_section_heading td_style_1 td_mb_30">
                  <h2 className="td_section_title td_fs_48 mb-0">About Us</h2>
                  <p
                    className="td_section_subtitle td_fs_18 mb-0"
                    dangerouslySetInnerHTML={{
                      __html: props?.aboutUsData[0]?.description,
                    }}
                  />
                </div>
                <div className="d-flex flex-wrap justify-contains-between gap-2">
                  {/* <Link
                  to="/about"
                  className="td_btn td_style_1 td_radius_10 td_medium"
                >
                  <span className="td_btn_in td_white_color td_accent_bg">
                    <span>Learn More</span>
                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.1575 4.34302L3.84375 15.6567"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                </Link> */}
                  <Link
                    to="/sast"
                    className="td_btn td_style_1 td_radius_10 td_medium custom-td_style_1"
                  >
                    <span className="td_btn_in custom_td_btn_in">
                      <span>Our Programs</span>
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1575 4.34302L3.84375 15.6567"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </Link>
                  <Link
                    to="/about"
                    className="td_btn td_style_1 td_radius_10 td_medium custom-td_style_1"
                  >
                    <span className="td_btn_in custom_td_btn_in">
                      <span>Who We Are</span>
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1575 4.34302L3.84375 15.6567"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </Link>
                  <button
                    type="button"
                    onClick={() => setShowBrochurePopup(true)}
                    className="td_btn td_style_1 td_radius_10 td_medium custom-td_style_1 border-0 bg-transparent"
                  >
                    <span className="td_btn_in custom_td_btn_in">
                      <span>View Brochures</span>

                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1575 4.34302L3.84375 15.6567"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showBrochurePopup && (
          <div
            className="pdf-overlay"
            onClick={() => setShowBrochurePopup(false)}
          >
            <div className="brochure-wrapper">
              <button
                type="button"
                className="pdf-close"
                onClick={() => setShowBrochurePopup(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>

              <div className="brochure-modal">
                <div className="brochure-header">
                  <h3>Brochures</h3>
                </div>

                <div className="brochure-body">
                  {brochures.map((brochure) => (
                    <Link
                      key={brochure.title}
                      to="#"
                      onClick={() => {
                        openViewer(brochure.link);
                        setShowBrochurePopup(false);
                      }}
                      className="brochure-item"
                    >
                      {brochure.title}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="td_height_120 td_height_lg_80" />
      </section>
      <PdfViwer open={openPdf} onClose={closeViewer} path={pdfPath} />
    </>
  );
};
